import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import facebook from '../../images/fb.png';
import instagram from '../../images/instagram.png';
import twitter from '../../images/twitter.png';
import tiktok from '../../images/tiktok.png';
import Slider from "react-slick";
import $ from 'jquery';
import { formatPrettyDate, beautyTime } from '../events/utils';
var socialIcons = {
  facebook: facebook,
  instagram: instagram,
  tiktok: tiktok,
  twitter: twitter
};
var PreviewVirtualBoothSlider = /*#__PURE__*/function (_Component) {
  function PreviewVirtualBoothSlider(props) {
    var _this;
    _classCallCheck(this, PreviewVirtualBoothSlider);
    _this = _callSuper(this, PreviewVirtualBoothSlider, [props]);
    _this.state = {
      loading: true,
      closing: false
    };
    _this.slideoutRef = /*#__PURE__*/React.createRef();
    _this.slideoutClose = /*#__PURE__*/React.createRef();
    _this.closeSlideout = _this.closeSlideout.bind(_this);
    _this.submitForm = _this.submitForm.bind(_this);
    return _this;
  }
  _inherits(PreviewVirtualBoothSlider, _Component);
  return _createClass(PreviewVirtualBoothSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;
      document.body.classList.add('modal-open');
      setTimeout(function () {
        self.setState({
          loading: false
        });
      }, 10);
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      $('form.acf-form').submit();
    }
  }, {
    key: "closeSlideout",
    value: function closeSlideout(event) {
      var self = this;
      if (this.slideoutRef && !this.slideoutRef.current.contains(event.target) || this.slideoutClose.current.contains(event.target)) {
        event.preventDefault();
        var timeout = window.screen.width < 768 ? 0 : 300;
        document.body.classList.remove('modal-open');
        this.setState({
          closing: true
        }, function () {
          setTimeout(function () {
            self.setState({
              closing: false
            });
            self.props.dismissPreviewModal();
          }, timeout);
        });
      }
      return;
    }
  }, {
    key: "render",
    value: function render() {
      var eventContent = this.props.eventContent;
      var _this$state = this.state,
        loading = _this$state.loading,
        closing = _this$state.closing;
      var selectedTestDay = 1;
      var selectedEventType = 'durational';
      var borderColor = '#FEF200';
      if (eventContent) {
        if (eventContent.event_themes && eventContent.event_themes.length > 0) {
          borderColor = eventContent.event_themes[0].color ? eventContent.event_themes[0].color : '#FEF200';
        }
      }
      var settings = {
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
      };
      var eventStatus = 'future';
      var rsvpLink = null;
      var rsvpLabel = 'RSVP';
      if (eventContent) {
        var today = new Date();
        if (selectedTestDay !== 1) {
          today = new Date(selectedTestDay + "T".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds()));
        }
        var eventStartDate = new Date(eventContent.date + 'T09:00:00');
        var eventEndDate = new Date(eventContent.date + 'T23:59:59');
        var weekStartDate = new Date('2020-11-14T09:00:00');
        rsvpLink = eventContent.rsvp ? eventContent.rsvp.url : null;
        // If IG event, set as follow us on IG
        if (eventContent.instagram_event) {
          rsvpLink = 'https://instagram.com/nycjewelryweek';
          rsvpLabel = 'Follow us to RSVP';
        }
        // If theres an RSVP link, set the label as its text
        if (eventContent.rsvp) {
          rsvpLabel = eventContent.rsvp.title ? eventContent.rsvp.title : 'RSVP';
        }
        // If the event is on now
        if (today > eventStartDate && today < eventEndDate || selectedEventType === 'durational' && today > weekStartDate) {
          eventStatus = 'present';
          rsvpLabel = 'Watch';
          if (eventContent.instagram_event) {
            rsvpLink = 'https://instagram.com/nycjewelryweek/live';
          } else {
            rsvpLink = 'https://youtube.com';
          }
          rsvpLink = eventContent.link ? eventContent.link.url : rsvpLink;
          if (eventContent.link) {
            rsvpLabel = eventContent.link.title ? eventContent.link.title : rsvpLabel;
            rsvpLink = eventContent.link.url;
          }
        }
        if (today > eventEndDate && selectedEventType !== 'durational') {
          eventStatus = 'past';
          rsvpLink = true;
          rsvpLabel = 'Event over';
        }
      }
      // If todays date is after the event end date

      return /*#__PURE__*/React.createElement("div", {
        id: "event-slideout",
        className: "".concat(loading ? 'loading' : '').concat(eventContent ? 'loaded' : '').concat(closing ? ' closing' : '').concat(eventContent.discover ? ' virtual-booth' : ''),
        onClick: this.closeSlideout
      }, /*#__PURE__*/React.createElement("div", {
        id: "event-slideout-wrapper",
        style: {
          borderColor: borderColor
        },
        ref: this.slideoutRef
      }, eventContent && /*#__PURE__*/React.createElement("div", {
        ref: this.slideoutClose,
        style: {
          borderColor: borderColor
        },
        onClick: this.closeSlideout,
        id: "close-slide"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Events"))), eventContent && /*#__PURE__*/React.createElement("div", {
        id: "event-slideout-content-wrapper",
        style: {
          paddingTop: 60
        }
      }, eventContent.images.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement(Slider, _extends({
        className: "event-image-gallery"
      }, settings), eventContent.images.map(function (image) {
        return /*#__PURE__*/React.createElement("div", {
          key: image.id,
          className: "event-image-wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "event-image",
          role: "img"
          // aria-label={ image.alt }
          ,
          style: {
            backgroundImage: "url(".concat(image.src, ")")
          }
        }));
      }))), /*#__PURE__*/React.createElement("div", {
        id: "event-slideout-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "event-slideout-header"
      }, (eventContent.event_types || eventContent.event_themes) && /*#__PURE__*/React.createElement("p", {
        className: "event-type"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          background: 'black',
          color: 'white'
        }
      }, "Discover")), /*#__PURE__*/React.createElement("h1", {
        className: "h2",
        dangerouslySetInnerHTML: {
          __html: eventContent.title ? eventContent.title : 'EVENT TITLE'
        }
      }), eventContent.social.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "event-social"
      }, eventContent.social.map(function (social) {
        return /*#__PURE__*/React.createElement("a", {
          key: "social-".concat(social.type),
          className: "social-link social-".concat(social.type),
          target: "_blank",
          href: social.link
        }, /*#__PURE__*/React.createElement("img", {
          src: socialIcons[social.type]
        }));
      })), eventContent.project_url && /*#__PURE__*/React.createElement("a", {
        className: "project-url bold uppercase text-button",
        style: {
          color: 'black'
        },
        href: eventContent.project_url
      }, "Website"), /*#__PURE__*/React.createElement("div", {
        className: "event-sub-header"
      }, eventContent.date && !eventContent.intro && eventContent.date.length === 1 && /*#__PURE__*/React.createElement("div", {
        className: "event-date"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, formatPrettyDate(eventContent.date[0]), eventContent.end_date && " - ".concat(formatPrettyDate(eventContent.end_date)))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, beautyTime(eventContent.start_time[0]), eventContent.end_time.length > 0 && "- ".concat(beautyTime(eventContent.end_time[0]))))))), eventContent.content && /*#__PURE__*/React.createElement("div", {
        className: "event-content",
        dangerouslySetInnerHTML: {
          __html: eventContent.content
        }
      }), eventContent.contactInfo && /*#__PURE__*/React.createElement("div", null, eventContent.contactInfo.email && /*#__PURE__*/React.createElement("p", {
        style: {
          marginBottom: 0,
          marginTop: 0,
          fontWeight: 'bold'
        }
      }, "Email: ", /*#__PURE__*/React.createElement("a", {
        style: {
          color: 'black'
        },
        href: "mailto:".concat(eventContent.contactInfo.email)
      }, eventContent.contactInfo.email)), eventContent.contactInfo.phone && /*#__PURE__*/React.createElement("p", {
        style: {
          marginBottom: 0,
          marginTop: 0,
          fontWeight: 'bold'
        }
      }, "Phone: ", /*#__PURE__*/React.createElement("a", {
        style: {
          color: 'black'
        },
        href: "tel:".concat(eventContent.contactInfo.phone)
      }, eventContent.contactInfo.phone))), /*#__PURE__*/React.createElement("div", {
        className: "text-centered follow-nycjw"
      }, /*#__PURE__*/React.createElement("a", {
        href: "https://instagram.com/nycjewelryweek",
        target: "_blank"
      }, /*#__PURE__*/React.createElement("img", {
        src: instagram
      }), /*#__PURE__*/React.createElement("span", null, "follow NYCJW on Instagram!"))), eventContent.isAvailableSubmit && /*#__PURE__*/React.createElement("div", {
        className: "text-right"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-submit-event ".concat(eventContent.title && eventContent.title.length > 0 ? '' : 'disabled'),
        onClick: this.submitForm
      }, $('input[type="submit"]').val())))), loading && /*#__PURE__*/React.createElement("div", {
        className: "event-loading-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "event-loading"
      }, "Loading"))));
    }
  }]);
}(Component);
export default PreviewVirtualBoothSlider;